<template>
    <div class="time-dispute-request">
        <RequestYearToolbar
            title="My Time Disputes"
            button-label="New Time Dispute"
            :year="selectedYear"
            @year-changed="handleYearChanged"
            @create="handleCreateButton"
        />
        <List
            :is-loading="isLoading"
            :total-count="totalCount"
            :current-page="currentPage"
            :limit="limit"
            :requests-data-list="requestList"
            @on-page-change="handleOnPageChanged"
            @reload="fetchRequests"
        />
        <CreateRequestModal ref="CreateRequest" @create="fetchRequests" />
    </div>
</template>

<script>
import moment from 'moment';
import CreateRequestModal from './CreateRequestModal';
import List from './list.vue';
import RequestYearToolbar from '../shared/RequestYearToolbar.vue';
import { normalizeRequest } from '../shared/normalizeRequest';
import { endOfDate, startOfDate } from '../../../../../utility/helper';
import { getPaginatedRequestRecordsByUserV2 } from '@/services/requests.services';

export default {
    components: {
        RequestYearToolbar,
        List,
        CreateRequestModal,
    },
    data() {
        return {
            isLoading: false,
            requestList: [],
            selectedYear: moment().year(),
            selectedUser: localStorage.getItem('user_id'),
            currentPage: 1,
            totalCount: 0,
            limit: 50,
        };
    },
    created() {
        this.fetchRequests();
    },
    methods: {
        handleCreateButton() {
            this.$refs.CreateRequest.openModal({ userId: this.selectedUser }, false);
        },
        handleYearChanged(year) {
            this.selectedYear = year;
            this.currentPage = 1;
            this.fetchRequests();
        },
        handleOnPageChanged(page) {
            this.currentPage = page;
            this.fetchRequests();
        },
        fetchRequests() {
            const yearStart = moment({ year: this.selectedYear, month: 0, date: 1 });
            const filter = {
                type: 'timedispute',
                createdAt: { $gte: startOfDate(yearStart), $lte: endOfDate(moment(yearStart).endOf('year')) },
            };
            this.isLoading = true;
            getPaginatedRequestRecordsByUserV2(filter, this.currentPage, this.limit)
                .then((res) => {
                    this.requestList = (res.data.data || []).map(normalizeRequest);
                    this.totalCount = res.data.totalCount || 0;
                })
                .catch(() => {
                    this.$Message.error('Failed to get time dispute requests');
                    this.requestList = [];
                    this.totalCount = 0;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
